import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import { DatePicker } from "@components/DatePicker";
import { YearPicker } from "@components/YearPicker";
import { withState } from "react-searchkit";

export class _SearchDateRange extends Component {
  getCurrentDates() {
    const {
      currentQueryState: { filters },
      fromDateFilter,
      toDateFilter,
    } = this.props;
    let fromDate = "";
    let toDate = "";

    filters.forEach(([name, value]) => {
      if (name === fromDateFilter) fromDate = value;
      if (name === toDateFilter) toDate = value;
    });
    return [fromDate, toDate];
  }

  onDateChange = (newFilter) => {
    const { currentQueryState, updateQueryState } = this.props;
    const filters = currentQueryState.filters;
    filters.push(newFilter);
    return updateQueryState({ filters: filters });
  };

  handleFromYearChange = (value) => {
    this.onDateChange([this.props.fromDateFilter, value]);
  };

  handleToYearChange = (value) => {
    this.onDateChange([this.props.toDateFilter, value]);
  };

  renderYearPickers() {
    const { fromPlaceholder, toPlaceholder } = this.props;
    const [fromYear, toYear] = this.getCurrentDates();

    return (
      <>
        <Card.Content>
          <YearPicker
            defaultValue={fromYear}
            placeholder={fromPlaceholder}
            handleYearChange={this.handleFromYearChange}
            name="fromYear"
          />
        </Card.Content>
        <Card.Content>
          <YearPicker
            defaultValue={toYear}
            placeholder={toPlaceholder}
            handleYearChange={this.handleToYearChange}
            name="toYear"
          />
        </Card.Content>
      </>
    );
  }

  renderDatePickers() {
    const { fromPlaceholder, toPlaceholder } = this.props;
    const [fromDate, toDate] = this.getCurrentDates();

    return (
      <>
        <Card.Content>
          <DatePicker
            maxDate={toDate}
            defaultValue={fromDate}
            placeholder={fromPlaceholder}
            handleDateChange={(value) =>
              this.onDateChange([this.props.fromDateFilter, value])
            }
          />
        </Card.Content>
        <Card.Content>
          <DatePicker
            minDate={fromDate}
            defaultValue={toDate}
            placeholder={toPlaceholder}
            handleDateChange={(value) =>
              this.onDateChange([this.props.toDateFilter, value])
            }
          />
        </Card.Content>
      </>
    );
  }

  render() {
    const { title, subtitle, yearOnly } = this.props;

    return (
      <Card>
        <Card.Content>
          <Card.Header>{title}</Card.Header>
          {subtitle && (
            <Card.Meta>
              <span>{subtitle}</span>
            </Card.Meta>
          )}
        </Card.Content>
        {yearOnly ? this.renderYearPickers() : this.renderDatePickers()}
      </Card>
    );
  }
}

export const SearchDateRange = withState(_SearchDateRange);

_SearchDateRange.propTypes = {
  currentQueryState: PropTypes.object.isRequired,
  updateQueryState: PropTypes.func.isRequired,
  fromDateFilter: PropTypes.string.isRequired,
  toDateFilter: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  fromPlaceholder: PropTypes.string,
  toPlaceholder: PropTypes.string,
  yearOnly: PropTypes.bool,
};

_SearchDateRange.defaultProps = {
  fromPlaceholder: "From",
  toPlaceholder: "To",
  yearOnly: false,
};
